import { Row } from "antd";
import React, { memo, useMemo } from "react";
import Warning from "src/components/GlobalIconPart/Warning";
import { AreaProps } from "src/entity/area/area.entity";
import { ResponseOthers } from "src/entity/others/information";

interface NumberRowProps {
  no: number;
  record: ResponseOthers;
  dataAreaInCompany: AreaProps[];
}

const NumberRow: React.FC<NumberRowProps> = memo(({ no, record, dataAreaInCompany }) => {
  const hasArea = useMemo(() => {
    return dataAreaInCompany.find((item) => item._id === record.area);
  }, [record, dataAreaInCompany]);

  const getTitleWarning = useMemo(() => {
    // const hasEmissionControl = record?.emissionControl?.isActive;
    const messageLists = [];
    if (!hasArea) messageLists.push("Area");
    // if (!hasEmissionControl) messageLists.push("Emission Control");

    return `${messageLists.join(",")} was deleted.`;
  }, [record, hasArea]);

  return (
    <Row justify={"center"}>
      {!hasArea ? <Warning title={getTitleWarning} /> : <></>}
      <div>{no}</div>
    </Row>
  );
});

export default NumberRow;
